import { connect } from "react-redux";

import LocationsView from "./LocationsView";
import { getLocations, setSearchStr } from "./LocationsState";
import LadsState from "../lads/LadsState";

function mapStateToProps(state) {
  return {
    locations: getLocations(state),
    lads: LadsState.selectors.getLadsList(state),
    searchStr: state.locations.searchStr
  };
}

function mapDispatchToProps(dispatch) {
  return {
    pushLocationEditScreen: locID =>
      dispatch({ type: "LOCATION_EDIT", payload: { location_id: locID } }),
    setSearchStr: str => dispatch(setSearchStr(str))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LocationsView);



// WEBPACK FOOTER //
// ./src/modules/locations/LocationsViewContainer.js